import { apiCall } from './gqlClient';

const NUTRITIONPLANS_QUERY = `
  query nutritionPlans($providerId: Float!) {
    nutritionPlans(providerId: $providerId)
    {
      id
			providerId
			clientUserId
			title
			description
			planType
			goalType
			startDate
			endDate
			notesClient
			notesInternal
			status
			workoutPlanId
			hideBrand
			hideQuantities
			hideMacros
			isTemplate
			imageId
			imageUrl
			coverUrl
			active
			price
			numberOfWeeks
			public
			archive
			planGroupId
			generation
			tier
			schedule
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const nutritionPlansApiCall = async ({providerId}, fragments = null) => apiCall({ query: NUTRITIONPLANS_QUERY, variables: {providerId}, fragments });

const NUTRITIONPLAN_QUERY = `
  query nutritionPlan($id: String!) {
    nutritionPlan(id: $id)
    {
      id
			providerId
			clientUserId
			title
			description
			planType
			goalType
			startDate
			endDate
			notesClient
			notesInternal
			status
			workoutPlanId
			hideBrand
			hideQuantities
			hideMacros
			isTemplate
			imageId
			imageUrl
			coverUrl
			active
			price
			numberOfWeeks
			public
			archive
			planGroupId
			generation
			tier
			schedule
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const nutritionPlanApiCall = async ({id}, fragments = null) => apiCall({ query: NUTRITIONPLAN_QUERY, variables: {id}, fragments });

const CLIENTNUTRITIONPLANS_QUERY = `
  query clientNutritionPlans($clientUserId: Float!) {
    clientNutritionPlans(clientUserId: $clientUserId)
    {
      id
			providerId
			clientUserId
			title
			description
			planType
			goalType
			startDate
			endDate
			notesClient
			notesInternal
			status
			workoutPlanId
			hideBrand
			hideQuantities
			hideMacros
			isTemplate
			imageId
			imageUrl
			coverUrl
			active
			price
			numberOfWeeks
			public
			archive
			planGroupId
			generation
			tier
			schedule
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const clientNutritionPlansApiCall = async ({clientUserId}, fragments = null) => apiCall({ query: CLIENTNUTRITIONPLANS_QUERY, variables: {clientUserId}, fragments });

const CREATENUTRITIONPLAN_QUERY = `
  mutation createNutritionPlan($input: NutritionPlanInput!) {
    createNutritionPlan(input: $input)
    {
      id
			providerId
			clientUserId
			title
			description
			planType
			goalType
			startDate
			endDate
			notesClient
			notesInternal
			status
			workoutPlanId
			hideBrand
			hideQuantities
			hideMacros
			isTemplate
			imageId
			imageUrl
			coverUrl
			active
			price
			numberOfWeeks
			public
			archive
			planGroupId
			generation
			tier
			schedule
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const createNutritionPlanApiCall = async ({input}, fragments = null) => apiCall({ query: CREATENUTRITIONPLAN_QUERY, variables: {input}, fragments });

const DUPLICATENUTRITIONPLAN_QUERY = `
  mutation duplicateNutritionPlan($id: String!) {
    duplicateNutritionPlan(id: $id)
    {
      id
			providerId
			clientUserId
			title
			description
			planType
			goalType
			startDate
			endDate
			notesClient
			notesInternal
			status
			workoutPlanId
			hideBrand
			hideQuantities
			hideMacros
			isTemplate
			imageId
			imageUrl
			coverUrl
			active
			price
			numberOfWeeks
			public
			archive
			planGroupId
			generation
			tier
			schedule
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const duplicateNutritionPlanApiCall = async ({id}, fragments = null) => apiCall({ query: DUPLICATENUTRITIONPLAN_QUERY, variables: {id}, fragments });

const UPDATENUTRITIONPLAN_QUERY = `
  mutation updateNutritionPlan($id: String!, $input: NutritionPlanInput!) {
    updateNutritionPlan(id: $id, input: $input)
    {
      id
			providerId
			clientUserId
			title
			description
			planType
			goalType
			startDate
			endDate
			notesClient
			notesInternal
			status
			workoutPlanId
			hideBrand
			hideQuantities
			hideMacros
			isTemplate
			imageId
			imageUrl
			coverUrl
			active
			price
			numberOfWeeks
			public
			archive
			planGroupId
			generation
			tier
			schedule
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const updateNutritionPlanApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATENUTRITIONPLAN_QUERY, variables: {id, input}, fragments });

const DELETENUTRITIONPLAN_QUERY = `
  mutation deleteNutritionPlan($id: String!) {
    deleteNutritionPlan(id: $id)
    {
      id
			providerId
			clientUserId
			title
			description
			planType
			goalType
			startDate
			endDate
			notesClient
			notesInternal
			status
			workoutPlanId
			hideBrand
			hideQuantities
			hideMacros
			isTemplate
			imageId
			imageUrl
			coverUrl
			active
			price
			numberOfWeeks
			public
			archive
			planGroupId
			generation
			tier
			schedule
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const deleteNutritionPlanApiCall = async ({id}, fragments = null) => apiCall({ query: DELETENUTRITIONPLAN_QUERY, variables: {id}, fragments });

const ARCHIVENUTRITIONPLAN_QUERY = `
  mutation archiveNutritionPlan($id: String!) {
    archiveNutritionPlan(id: $id)
    {
      id
			providerId
			clientUserId
			title
			description
			planType
			goalType
			startDate
			endDate
			notesClient
			notesInternal
			status
			workoutPlanId
			hideBrand
			hideQuantities
			hideMacros
			isTemplate
			imageId
			imageUrl
			coverUrl
			active
			price
			numberOfWeeks
			public
			archive
			planGroupId
			generation
			tier
			schedule
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const archiveNutritionPlanApiCall = async ({id}, fragments = null) => apiCall({ query: ARCHIVENUTRITIONPLAN_QUERY, variables: {id}, fragments });

const RESTORENUTRITIONPLAN_QUERY = `
  mutation restoreNutritionPlan($id: String!) {
    restoreNutritionPlan(id: $id)
    {
      id
			providerId
			clientUserId
			title
			description
			planType
			goalType
			startDate
			endDate
			notesClient
			notesInternal
			status
			workoutPlanId
			hideBrand
			hideQuantities
			hideMacros
			isTemplate
			imageId
			imageUrl
			coverUrl
			active
			price
			numberOfWeeks
			public
			archive
			planGroupId
			generation
			tier
			schedule
			dateCreated
			dateUpdated
      ...fragments
    }
  }`;

export const restoreNutritionPlanApiCall = async ({id}, fragments = null) => apiCall({ query: RESTORENUTRITIONPLAN_QUERY, variables: {id}, fragments });
